// uiCore/SbBadge/SbBadge.jsx

import React from "react";
import { Badge } from "antd";

const SbBadge = ({
  count,
  children,
  ...rest
}) => {
  return (
    <Badge
      count={count}
      {...rest}
    >
      {children}
    </Badge>
  );
};

export default SbBadge;